module.exports = __webpack_public_path__ + "static/media/caret-down-red-colored-filled.04c69c9b.svg";